import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import {
  ITag, ITagAsset, ITagAssetResponse, ITagCreate, ITagPut,
} from './interfaces';

const basePath = '/tags';
const updateAssetPath = `${basePath}/updateAssets`;

export const getAllTags = <T>(): AxiosPromise<IApiResponse<Array<ITag>>> => vaultApi.getInstance().get(basePath);

export const getTagById = <T>(id: string): AxiosPromise<IApiResponse<ITag>> => vaultApi.getInstance().get(`${basePath}/${id}`);

export const getTagsByOrgId = <T>(orgId: number): AxiosPromise<IApiResponse<Array<ITag>>> => vaultApi.getInstance().get(`${basePath}/getByOrgId?orgId=${orgId}`);

export const createTag = <T>(params: ITagCreate): AxiosPromise<IApiResponse<ITag>> => vaultApi.getInstance().post(basePath, params);

export const updateTag = <T>(id: string, params: ITagPut): AxiosPromise<IApiResponse<ITag>> => vaultApi.getInstance().put(`${basePath}/${id}`, params);

export const deleteTag = <T>(id: string): AxiosPromise<any> => vaultApi.getInstance().delete(`${basePath}/${id}`);

export const addTagToAsset = <T>(params: ITagAsset): AxiosPromise<IApiResponse<ITagAssetResponse>> => vaultApi.getInstance().put(`${updateAssetPath}/add`, params);

export const removeTagFromAsset = <T>(params: ITagAsset): AxiosPromise<IApiResponse<ITagAssetResponse>> => vaultApi.getInstance().put(`${updateAssetPath}/remove`, params);
